import { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "../providers/AuthContext"; // Import useAuth
import { getAllTenantsForUsers } from "../api/Tenants"; // Import the function to get user tenants
import { getAgreementsForUser } from "../api/Agreement"; // Import the function to get user tenants
import { getScoFormSettings } from "../api/Users";

// Skapa kontexten
const SidebarContext = createContext();

// Custom hook för enkel åtkomst till SidebarContext
export const useSidebar = () => useContext(SidebarContext);

// SidebarProvider som vi kommer använda runt hela appen 
export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { user, getAccessToken, isRole } = useAuth(); // Destructure getAccessToken
  const [tenants, setTenants] = useState([]);
  const [agreements, setAgreements] = useState([]);
  const [isSticky, setIsSticky] = useState(true); // State for sticky sidebar
  // SCO form capabilities of the API (feature #301): decides which SCO entries the sidebar shows.
  const [scoFormSettings, setScoFormSettings] = useState(null);

    useEffect(() => {
      const fetchScoFormSettings = async () => {
        try {
          const accessToken = await getAccessToken();
          setScoFormSettings(await getScoFormSettings(accessToken));
        } catch (error) {
          setScoFormSettings(null);
        }
      };

      const fetchAgreements = async () => {
        try {
          const accessToken = await getAccessToken();
          const userAgreements = await getAgreementsForUser(accessToken);
          setAgreements(userAgreements);
        } catch (error) {
          console.error("Failed to fetch agreements:", error);
        }
      };
  
      const fetchTenants = async () => {
        try {
          const accessToken = await getAccessToken();
          const userTenants = await getAllTenantsForUsers(accessToken);
          setTenants(userTenants);
        } catch (error) {
          console.error("Failed to fetch tenants:", error);
        }
      };
  
      fetchAgreements();
      fetchTenants();
      fetchScoFormSettings();
    }, [getAccessToken, user]);

const toggleSidebar = () => {
  setIsSidebarOpen((prev) => !prev)
};



  return (
    <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar, setIsSidebarOpen, tenants, agreements, isSticky, setIsSticky, scoFormSettings }}>
      {children}
    </SidebarContext.Provider>
  );
} 
